export default __webpack_public_path__ + "b0e64a8a9eecc30699dbe9b417294681.png";